import React, { Component } from 'react'
import { getFirebase } from "../../utils/Firestore";
import posed from 'react-pose'
import styled from 'styled-components'
import { IconContext } from "react-icons";
import { FiCheck } from "react-icons/fi";
import HoneyPot from './HoneyPot'

const Message = posed.div({
  visible: {
    x: 0,
    opacity: 1
  },
  hidden: {
    x: -50,
    opacity: 0
  },
});

const MessageWrapper = posed.div({
  visible: {
    x: 0,
    opacity: 1
  },
  hidden: {
    x: -50,
    opacity: 0
  },
});

const InputWrapper = styled.div`
  ${tw`flex items-center justify-between mb-2`}
`
const inputFieldClasses = `flex-1 bg-white font-mono text-sm lg:text-base appearance-none border-2 border-secondary-light w-full py-1 lg:py-2 px-2 lg:px-4 text-primary leading-tight focus:outline-none focus:bg-white font-mono focus:border-primary`

class ContactForm extends Component {
  state = {
    submit: false,
    subject: "",
    name: "",
    email: "",
    phone: "",
    message: "",
    honeypotFullName: "",
    honeypotConfirmEmail: "",
    database: null,
  }

  handleInputChange = event => {
    const target = event.target
    const value = target.value
    const name = target.name

    //Different approach with honeypot fields to avoid give
    //the fields an explicit honeypot label
    if(name == 'fullName'){
      this.setState({'honeypotFullName': value})
    } else if (name == 'confirmEmail') {
      this.setState({'honeypotConfirmEmail': value})
    } else {
      this.setState({
        [name]: value,
      })
    }
  }

  handleSubmit = event => {
    event.preventDefault()

    const { database } = this.state;

    //Check if honeypot fields are empty
    if (this.state.honeypotFullName == '' && this.state.honeypotConfirmEmail == ''){
      if (database) {
        const contactRef = database.collection('contact').add({
          subject: this.state.subject,
          name: this.state.name,
          email: this.state.email,
          phone: this.state.phone,
          message: this.state.message,
        });
      }

      this.setState({
        submit: true,
        subject: "",
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    } else {
      // return if any of the honeypot fields is not empty
      return
    }
  }

  componentDidUpdate() {
    const { database } = this.state;
    if (!database) {
      const lazyApp = import('firebase/app')
      const lazyDatabase = import('firebase/firestore')

      Promise.all([lazyApp, lazyDatabase]).then(([firebase]) => {
        const database = getFirebase(firebase).firestore()
        this.setState({ database: database })
      })
    }

    const { submit } = this.state;

    if (submit) {
      setTimeout(() => {
        this.setState({ submit: !submit });
      }, 4000);
    }
  }

  render() {
    const { submit } = this.state;

    return(
      <div className='flex justify-center'>
        <div className="w-full max-w-sm">
            <IconContext.Provider key="scroll" value={{ color: "white", className: "scroll-icon", size: "1.4em" }}>
              <Message className="text-white text-center p-1 font-mono bg-primary mb-1" pose={submit ? 'visible' : 'hidden'}>
                <FiCheck className="inline-block align-middle pr-1"/>
                <span className="inline-block align-middle">The message has been sent!</span>
              </Message>
            </IconContext.Provider>

          <form
            className='mb-0'
            onSubmit={this.handleSubmit}
          >
            <InputWrapper>
              <input
                required
                className={inputFieldClasses}
                type="text"
                name="subject"
                aria-label="subject"
                value={this.state.subject}
                onChange={this.handleInputChange}
                placeholder="Subject"
              />
            </InputWrapper>
            <InputWrapper>
              <input
                required
                className={inputFieldClasses}
                type="text"
                name="name"
                aria-label="name"
                value={this.state.name}
                onChange={this.handleInputChange}
                placeholder="Name"
              />
            </InputWrapper>
            <HoneyPot
              fullName={this.state.honeypotFullName}
              confirmEmail={this.state.honeypotConfirmEmail}
              handleInputChange={this.handleInputChange}
            />
            <InputWrapper>
              <input
                required
                className={inputFieldClasses}
                type="email"
                name="email"
                aria-label="email"
                value={this.state.email}
                onChange={this.handleInputChange}
                placeholder="Email"
              />
            </InputWrapper>
            {/*
            <InputWrapper>
              <input
                className={inputFieldClasses}
                type="tel"
                name="phone"
                value={this.state.phone}
                onChange={this.handleInputChange}
                placeholder="Phone"
              />
            </InputWrapper>
            */}
            <InputWrapper>
              <textarea
                required
                className={inputFieldClasses}
                type="text"
                name="message"
                aria-label="message"
                value={this.state.message}
                onChange={this.handleInputChange}
                placeholder="Message"
              />
            </InputWrapper>
            <div className="flex items-center justify-end">
              <button className='btn btn-primary font-mono rounded-none' type="submit" aria-label="Send">Send</button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}


export default ContactForm;
